<template>
  <ModelCarsoule  :slides="items" parentFolder="Services" />
</template>

<script>
import ModelCarsoule from "@/components/global/compnentsMixins/ModelCarsoule.vue";
export default {
  components: { ModelCarsoule },
  data() {
    return {
      items: [
        {
          imageName: "Aged_Invoices_Receivable.jpeg",
          alt: "Aged_Invoices_Receivable",
        },
        {
          imageName: "Billable_Time_Spent.jpeg",
          alt: "Billable_Time_Spent",
        },
        {
          imageName: "Aged_Invoices_Receivable.jpeg",
          alt: "Aged_Invoices_Receivable",
        },
        {
          imageName: "Staff_Productivity_Dashboard.jpeg",
          alt: "Staff_Productivity_Dashboard",
        },
        {
          imageName: "Staff_Productivity_Dashboard.jpeg",
          alt: "Staff_Productivity_Dashboard",
        },
        {
          imageName: "Business-Pulse-upgrade.jpeg",
          alt: "Business-Pulse-upgrade",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
</style>